<div class="side-sheet" [ngClass]="{'active': selectedSessionId}">
    <div class="d-flex h-100">

        <div class="overlay" (click)="close.emit()"></div>

        <div class="sheet-container">
            <div class="sheet-head">
                <div class="title">
                    {{ 'ConsultationSessions.Consultation session details' | translate }}
                </div>

                <button type="button" mat-icon-button (click)="close.emit()">
                    <img src="./assets/images/icons/ic_close.svg" alt="">
                </button>
            </div>

            <div *ngIf='dataLoading' class="dataLoading">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
            </div>
            <!--  -->
            <ng-container *ngIf="!dataLoading">
                <div class="sheet-content p-0 session-details">
                    <div class="top-header">
                        <div class="text">
                            <p>{{'supportTicket.ID' | translate}}:</p>
                            <h1>{{details.request.references_number}}</h1>
                        </div>
                        <div class="status">
                            @switch (details.request.status.id) {
                            @case (session_STATUS.new) {
                            <div class="status-badge blue">
                                {{ 'ConsultationSessions.Recently requested' | translate }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="14.247" height="16"
                                    viewBox="0 0 14.247 16">
                                    <path id="Path_89415" data-name="Path 89415"
                                        d="M6493.065-1059.8h-2.157a4.784,4.784,0,0,1-3.874-1.994l-2.48-3.477a1.921,1.921,0,0,1-.254-1.718,1.9,1.9,0,0,1,1.373-1.254,2.044,2.044,0,0,1,.438-.048,1.9,1.9,0,0,1,1.05.311l.157.1v-3.573a1.923,1.923,0,0,1,1.919-1.921,1.928,1.928,0,0,1,.391.041l.123.026v-.578a1.946,1.946,0,0,1,1.919-1.921,1.913,1.913,0,0,1,1.895,1.586l.018.1.1-.023a2.064,2.064,0,0,1,.419-.046,1.926,1.926,0,0,1,1.065.322,1.933,1.933,0,0,1,.826,1.265l.019.106.1-.023a1.836,1.836,0,0,1,.409-.048h.006a1.926,1.926,0,0,1,1.913,1.921v3.323a8.942,8.942,0,0,1-.337,2.418l-.469,1.647A4.774,4.774,0,0,1,6493.065-1059.8Zm-6.957-7.076a.371.371,0,0,0-.076.008.137.137,0,0,1-.04.005l-.02,0a.482.482,0,0,0-.339.32.5.5,0,0,0,.066.451l2.48,3.477a3.372,3.372,0,0,0,2.727,1.4h2.157a3.388,3.388,0,0,0,3.223-2.43l.471-1.643a7.371,7.371,0,0,0,.285-1.833l0-.1h-.008v-3.419a.519.519,0,0,0-.512-.512.519.519,0,0,0-.512.512v2.838a.7.7,0,0,1-.7.7.7.7,0,0,1-.7-.7v-4.46a.519.519,0,0,0-.512-.512.519.519,0,0,0-.512.512v4.46a.7.7,0,0,1-.7.7.705.705,0,0,1-.706-.7v-6.08a.519.519,0,0,0-.51-.514.52.52,0,0,0-.514.514v6.08a.7.7,0,0,1-.7.7.7.7,0,0,1-.7-.7v-3.649a.519.519,0,0,0-.512-.512.519.519,0,0,0-.512.512v5.277a.71.71,0,0,1-.432.649.705.705,0,0,1-.279.056.689.689,0,0,1-.5-.21l-1.051-1.052A.475.475,0,0,0,6486.108-1066.875Z"
                                        transform="translate(-6484.2 1075.799)" fill="#076cb4" />
                                </svg>
                            </div>
                            }
                            @case (session_STATUS.upcoming) {
                            <div class="status-badge yellow">
                                {{ 'ConsultationSessions.Upcoming consultation' | translate }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="upcoming_session_ic" transform="translate(-1018)">
                                        <rect id="container" width="20" height="20" transform="translate(1018)"
                                            fill="none" />
                                        <path id="Path_89413" data-name="Path 89413"
                                            d="M13.024,15.764a.809.809,0,0,1,0-1.142l1.027-1.027-1.027-1.028a.807.807,0,1,1,1.141-1.14l1.6,1.6a.809.809,0,0,1,0,1.141l-1.6,1.6a.808.808,0,0,1-1.141,0Zm-4,0a.806.806,0,0,1,0-1.141l1.026-1.028L9.029,12.566a.806.806,0,1,1,1.14-1.14l1.6,1.6a.808.808,0,0,1,0,1.141l-1.6,1.6a.807.807,0,0,1-1.14,0ZM2.4,16A2.407,2.407,0,0,1,0,13.6V4A2.408,2.408,0,0,1,2.4,1.6H3.2V.807a.807.807,0,1,1,1.614,0V1.6H11.19V.807a.807.807,0,1,1,1.613,0V1.6h.791A2.409,2.409,0,0,1,16,4V9.6a.807.807,0,0,1-1.614,0V6.41H1.613V13.6a.792.792,0,0,0,.791.79h4A.807.807,0,1,1,6.4,16ZM1.613,4V4.8H14.386V4a.793.793,0,0,0-.791-.792H2.4A.793.793,0,0,0,1.613,4Z"
                                            transform="translate(1020 2)" fill="#f2cb00" />
                                    </g>
                                </svg>
                            </div>
                            }
                            @case (session_STATUS.ongoing) {
                            <div class="status-badge dark-green">
                                {{ 'ConsultationSessions.Ongoing Consultation' | translate }}
                                <svg id="ongoing_session_ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                    viewBox="0 0 20 20">
                                    <rect id="container" width="20" height="20" fill="none" />
                                    <g id="Group_15117" data-name="Group 15117" transform="translate(-5.733 1.999)">
                                        <path id="Path_89467" data-name="Path 89467"
                                            d="M287.3,22.77a.7.7,0,1,1,.7-.7A.7.7,0,0,1,287.3,22.77Z"
                                            transform="translate(-270.149 -20.703)" fill="#3eb6b6" opacity="0.4" />
                                        <path id="Path_89468" data-name="Path 89468"
                                            d="M459.513,264.046h0a.7.7,0,1,1,.7.765A.7.7,0,0,1,459.513,264.046Z"
                                            transform="translate(-437.658 -255.181)" fill="#3eb6b6" opacity="0.8" />
                                        <path id="Path_89469" data-name="Path 89469"
                                            d="M452.859,183.87a.7.7,0,1,1,.856.495.708.708,0,0,1-.181.024A.7.7,0,0,1,452.859,183.87Z"
                                            transform="translate(-431.192 -177.27)" fill="#3eb6b6" opacity="0.7" />
                                        <path id="Path_89470" data-name="Path 89470"
                                            d="M418.478,111.167a.7.7,0,1,1,.569.292A.7.7,0,0,1,418.478,111.167Z"
                                            transform="translate(-397.782 -106.621)" fill="#3eb6b6" opacity="0.6" />
                                        <path id="Path_89471" data-name="Path 89471"
                                            d="M360.581,54.11a.7.7,0,1,1,.579,1.09A.7.7,0,0,1,360.581,54.11Z"
                                            transform="translate(-341.704 -52.119)" fill="#3eb6b6" opacity="0.5" />
                                        <path id="Path_89472" data-name="Path 89472"
                                            d="M438.329,342.534a.7.7,0,1,1,.7-.7A.7.7,0,0,1,438.329,342.534Z"
                                            transform="translate(-416.462 -330.474)" fill="#3eb6b6" opacity="0.9" />
                                        <path id="Path_89473" data-name="Path 89473"
                                            d="M20.954,12.695a.7.7,0,0,0-.937.045A6.38,6.38,0,1,1,12.632,2.529l.225.921a.28.28,0,0,0,.471.13l2.139-2.165a.28.28,0,0,0-.113-.463l-2.9-.937A.28.28,0,0,0,12.1.347l.193.793A7.779,7.779,0,1,0,21,13.73.7.7,0,0,0,20.954,12.695Z"
                                            transform="translate(0 0)" fill="#3eb6b6" />
                                    </g>
                                </svg>
                            </div>
                            }
                            @case (session_STATUS.finished) {
                            <div class="status-badge green">
                                {{ 'ConsultationSessions.Finished Consultation' | translate }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="completed_session_ic" transform="translate(-1018)">
                                        <rect id="container" width="20" height="20" transform="translate(1018)"
                                            fill="none" />
                                        <path id="Verified_active_account_ic"
                                            d="M86.88-870.56l-1.72-1.72a.759.759,0,0,0-.56-.22.759.759,0,0,0-.56.22.759.759,0,0,0-.22.56.759.759,0,0,0,.22.56l2.28,2.28a.768.768,0,0,0,.56.24.768.768,0,0,0,.56-.24l4.52-4.52a.759.759,0,0,0,.22-.56.759.759,0,0,0-.22-.56.759.759,0,0,0-.56-.22.759.759,0,0,0-.56.22ZM88-864a7.79,7.79,0,0,1-3.12-.63,8.079,8.079,0,0,1-2.54-1.71,8.078,8.078,0,0,1-1.71-2.54A7.79,7.79,0,0,1,80-872a7.79,7.79,0,0,1,.63-3.12,8.079,8.079,0,0,1,1.71-2.54,8.079,8.079,0,0,1,2.54-1.71A7.789,7.789,0,0,1,88-880a7.789,7.789,0,0,1,3.12.63,8.079,8.079,0,0,1,2.54,1.71,8.079,8.079,0,0,1,1.71,2.54A7.79,7.79,0,0,1,96-872a7.79,7.79,0,0,1-.63,3.12,8.079,8.079,0,0,1-1.71,2.54,8.079,8.079,0,0,1-2.54,1.71A7.79,7.79,0,0,1,88-864Zm0-1.6a6.177,6.177,0,0,0,4.54-1.86A6.177,6.177,0,0,0,94.4-872a6.177,6.177,0,0,0-1.86-4.54A6.177,6.177,0,0,0,88-878.4a6.177,6.177,0,0,0-4.54,1.86A6.177,6.177,0,0,0,81.6-872a6.177,6.177,0,0,0,1.86,4.54A6.177,6.177,0,0,0,88-865.6ZM88-872Z"
                                            transform="translate(939.999 882)" fill="#43a047" />
                                    </g>
                                </svg>
                            </div>
                            }
                            @case (session_STATUS.cancelled) {
                            <div class="status-badge danger">
                                {{ 'ConsultationSessions.Cancelled Consultation' | translate }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g id="cancelled_session_ic" transform="translate(-1018)">
                                        <rect id="container" width="20" height="20" transform="translate(1018)"
                                            fill="none" />
                                        <path id="cancel_FILL0_wght400_GRAD0_opsz24"
                                            d="M88-870.88l2.32,2.32a.759.759,0,0,0,.56.22.759.759,0,0,0,.56-.22.759.759,0,0,0,.22-.56.759.759,0,0,0-.22-.56L89.12-872l2.32-2.32a.759.759,0,0,0,.22-.56.759.759,0,0,0-.22-.56.759.759,0,0,0-.56-.22.759.759,0,0,0-.56.22L88-873.12l-2.32-2.32a.759.759,0,0,0-.56-.22.759.759,0,0,0-.56.22.759.759,0,0,0-.22.56.759.759,0,0,0,.22.56L86.88-872l-2.32,2.32a.759.759,0,0,0-.22.56.759.759,0,0,0,.22.56.759.759,0,0,0,.56.22.759.759,0,0,0,.56-.22ZM88-864a7.79,7.79,0,0,1-3.12-.63,8.079,8.079,0,0,1-2.54-1.71,8.078,8.078,0,0,1-1.71-2.54A7.79,7.79,0,0,1,80-872a7.79,7.79,0,0,1,.63-3.12,8.079,8.079,0,0,1,1.71-2.54,8.079,8.079,0,0,1,2.54-1.71A7.789,7.789,0,0,1,88-880a7.789,7.789,0,0,1,3.12.63,8.079,8.079,0,0,1,2.54,1.71,8.079,8.079,0,0,1,1.71,2.54A7.79,7.79,0,0,1,96-872a7.79,7.79,0,0,1-.63,3.12,8.079,8.079,0,0,1-1.71,2.54,8.079,8.079,0,0,1-2.54,1.71A7.79,7.79,0,0,1,88-864Zm0-1.6a6.177,6.177,0,0,0,4.54-1.86A6.177,6.177,0,0,0,94.4-872a6.177,6.177,0,0,0-1.86-4.54A6.177,6.177,0,0,0,88-878.4a6.177,6.177,0,0,0-4.54,1.86A6.177,6.177,0,0,0,81.6-872a6.177,6.177,0,0,0,1.86,4.54A6.177,6.177,0,0,0,88-865.6ZM88-872Z"
                                            transform="translate(940 882)" fill="#fb4456" />
                                    </g>
                                </svg>
                            </div>
                            }
                            }
                        </div>
                    </div>
                    <div class="card-with-heads-footers blue">
                        <div class="card-head">
                            {{'ConsultationSessions.Consultation Requester' | translate }}:
                        </div>
                        <div class="card-body">
                            <div class="name-with-image">
                                <div class="image-circle">
                                    <img *ngIf="details.request.user.image" [src]="details.request.user.image"
                                        (error)='details.request.user.image = ""'>
                                    <span *ngIf="!details.request.user.image">
                                        {{ details.request.user.name| shortName }}
                                    </span>
                                </div>
                                <div class="name">
                                    <h6 class="font-18 fontRegular"> {{ details.request.user.name }}</h6>

                                </div>
                            </div>
                            <div class="name-with-image">
                                <div class="image-square">
                                    <img *ngIf="details.request.user.company.company_logo"
                                        [src]="details.request.user.company.company_logo"
                                        (error)='details.request.user.company.company_logo = ""'>
                                    <span *ngIf="!details.request.user.company.company_logo">
                                        {{ details.request.user.company.name_en| shortName }}
                                    </span>
                                </div>
                                <div class="name">
                                    <h6 class="font-18 fontRegular mb-2"> {{details.request.user.company.name_ar}}</h6>
                                    <h6 class="font-18 fontRegular">{{details.request.user.company.name_en}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-with-heads-footers grey" *ngIf="details.request?.consultant">
                        <div class="card-head">
                            {{'ConsultationSessions.Consultant' | translate }}:
                        </div>
                        <div class="card-body">
                            <div class="name-with-image">
                                <div class="image-circle">
                                    <img *ngIf="details.request.consultant.image"
                                        [src]="details.request.consultant.image"
                                        (error)='details.request.consultant.image = ""'>
                                    <span *ngIf="!details.request.consultant.image">
                                        {{ details.request.consultant.name| shortName }}
                                    </span>
                                </div>
                                <div class="name">
                                    <h6 class="font-18 fontRegular"> {{ details.request.consultant.name }}</h6>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="session-date-time" *ngIf="details.request.status.id != session_STATUS.new">
                        <div class="icon">
                            <img src="./assets/images/icons/consultants/session_datetime_ic.svg" alt="">
                        </div>
                        <div class="content">
                            <h4>{{'ConsultationSessions.Scheduled Session Time' | translate}}</h4>
                            <h2 *ngIf="details.request.start_at">{{details.request.start_at | date:'d MMMM y - h:mm a'
                                }}</h2>

                            <!-- <p class="green">{{'ConsultationSessions.The session started earlier than this time' |
                                translate}} <b>2 {{'employeeProfile.Minute' | translate}}</b></p> -->
                            <p class="red" *ngIf="!details.request.start_at">
                                {{'ConsultationSessions.Appointment Not Agreed Upon' | translate}}</p>
                        </div>
                    </div>
                    <mat-accordion class="main-accordion" [multi]="true">
                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ 'ConsultationSessions.Session Dates and Actions Record' | translate }}
                                </mat-panel-title>
                                <mat-panel-description>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="expansion-body">
                                @if (details.history && details.history.length) {
                                <div class="step {{item.class}}" *ngFor="let item of details.history">
                                    <div class="v-stepper">
                                        <div class="circle"></div>
                                        <div class="line"></div>
                                    </div>

                                    <div class="content">
                                        <p>{{item.created_at | date:'d MMMM y - h:mm a' }}</p>
                                        <h2>{{item.name}}</h2>
                                        <div class="name-with-image">
                                            <div class="image-circle">
                                                <img *ngIf="item.user.image" [src]="item.user.image"
                                                    (error)='item.user.image = ""'>
                                                <span *ngIf="!item.user.image" class="font-11 fontRegular">
                                                    {{ item.user.name| shortName }}
                                                </span>
                                            </div>
                                            <div class="name">
                                                <h6 class="font-14 fontRegular">{{ item.user.name }}</h6>

                                            </div>
                                        </div>
                                        <div class="rate" *ngIf="item.rate">
                                            <p>{{item.rate}}
                                                <img src="./assets/images/icons/consultants/star-filled.png" alt="">
                                            </p>
                                        </div>
                                        <div class="reason-for-change" *ngIf="item.note">
                                            <p>{{item.label}}:</p>
                                            <h3>{{item.note}}</h3>
                                        </div>
                                        <div class="old-date-new-date" *ngIf="item.new_date && item.old_date">
                                            <div class="old">
                                                <p>{{ 'ConsultationSessions.Previous Session Time' | translate }}</p>
                                                <h3>{{item.old_date | date:'d MMMM y - h:mm a' }} </h3>
                                            </div>
                                            <div class="new">
                                                <p>{{ 'ConsultationSessions.Rescheduled Session Time' | translate }}</p>
                                                <h3>{{item.new_date | date:'d MMMM y - h:mm a' }} </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }@else {
                                <empty-state [title]='"general.No Data Found" | translate'
                                    [img]="'no image'"></empty-state>
                                }
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ 'ConsultationSessions.Request Details' | translate }}
                                </mat-panel-title>
                                <mat-panel-description>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="expansion-body">
                                <div class="section">
                                    <p>{{'consultant.specialty' | translate}}</p>
                                    <h2>{{details.request.specialty}}</h2>
                                </div>
                                <div class="section">
                                    <p>{{'ConsultationSessions.Session Method' | translate}}</p>
                                    <h2>
                                        @switch (details.request.type) {
                                        @case(Session_TYPE.Chat){
                                        <img src="./assets/images/icons/consultants/consultation_session_type_chat_ic.svg"
                                            alt="">
                                        {{'ConsultationSessions.Chat session' | translate}}
                                        }
                                        @case(Session_TYPE.Vedio){
                                        <img src="./assets/images/icons/consultants/consultation_session_type_video_ic.svg"
                                            alt="">
                                        {{'ConsultationSessions.Video session' | translate}}
                                        }
                                        @case(Session_TYPE.Voice){
                                        <img src="./assets/images/icons/consultants/consultation_session_type_voice_ic.svg"
                                            alt="">
                                        {{'ConsultationSessions.Audio session' | translate}}
                                        }
                                        @default{
                                        <img src="./assets/images/icons/consultants/consultation_session_type_chat_ic.svg"
                                            alt="">
                                        {{'ConsultationSessions.Chat session' | translate}}
                                        }
                                        }
                                    </h2>
                                </div>
                                <div class="section">
                                    <p>{{'ConsultationSessions.Session Type' | translate}}</p>
                                    <span [ngSwitch]="details.request.is_free">
                                        <h2 *ngSwitchCase="true" class="font-18 fontRegular grey-color">
                                            {{details.request.price}} <span
                                                class="font-14 light-grey-color">{{'companies.point'
                                                |
                                                translate}}</span>
                                        </h2>
                                        <h2 *ngSwitchCase="false" class="font-18 fontRegular grey-color">
                                            {{'ConsultationSessions.Free session' |
                                            translate}}
                                        </h2>
                                    </span>
                                    <h2>{{details.request.is_free ? ('ConsultationSessions.Free session'|translate):
                                        details.request.price}}
                                        <span *ngIf="!details.request.is_free"
                                            class="font-14 light-grey-color">{{'companies.point' | translate}}</span>
                                    </h2>
                                </div>
                                <div class="section">
                                    <p>{{'ConsultationSessions.Consultant gender' | translate}}</p>
                                    <h2>
                                        @switch (details.request.gender) {
                                        @case ('female') { {{"consultant.female"|translate}} }
                                        @case ('male') { {{"consultant.male"|translate}} }
                                        @case ('all') { {{"offers.All"|translate}} }
                                        }
                                    </h2>
                                </div>
                                <!-- <div class="section">
                                    <p>{{'ConsultationSessions.How the Requester Feels' | translate}}</p>
                                    <h2>أشعر بضغط كبير في العمل، وأحتاج إلى استشارة نفسية لأتمكن من التعامل مع التوتر
                                        والقلق الذي يؤثر على أدائي. أريد من يساعدني في فهم مشاعري وإيجاد طرق للتعامل مع
                                        التحديات التي أواجهها في بيئة العمل</h2>
                                </div> -->
                                <div class="section">
                                    <p>{{'ConsultationSessions.General Notes' | translate}}</p>
                                    <h2>لا يوجد</h2>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </ng-container>
        </div>
    </div>
</div>